<template>
    <section v-if="sortedItems.length" class="NewsGrid">
        <div class="container container--no-pad">
            <BaseHeading
                :preheading="preheading"
                :heading="heading"
                :tag="tag"
                class="text--black text--center mb-medium desk-mb-large h1"
            />
            <div :class="gridClassObject">
                <NewsCard
                    v-for="item in sortedItems"
                    :key="item.id"
                    :item="item"
                    :tag="item.productLocations"
                />
            </div>
        </div>
    </section>
</template>
<script>
import NewsCard from './NewsCard.vue'
export default {
    name: 'NewsGrid',
    components: {
        NewsCard
    },
    props: {
        heading: {
            type: String,
            default: null
        },
        preheading: {
            type: String,
            default: null
        },
        items: {
            type: Array,
            default: null
        },
        eventsToFront: {
            type: Array,
            default: null
        },
        limit: {
            type: Number,
            default: 3
        },
        tag: {
            type: String,
            default: 'h1'
        },
        isDestination: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        sortedItems() {
            const items = this.items.filter((a) => {
                if (this.isDestination) {
                    return ((a.featured || a.subregionalFeatured) && a.inActiveRegion && a.type == 'event')
                } else {
                    return (a.featured && a.inActiveRegion && a.type == 'event')
                }
            });

            const sortedItems = items.sort((a, b) => a.timestamp - b.timestamp);

            const sorted = [...this.eventsToFront, ...sortedItems];

            return sorted.slice(0, this.limit)
        },
        gridClassObject() {
            return {
                'NewsGrid__list' : true,
                'NewsGrid__list--large' : this.limit > 3
            }
        }
    }
}
</script>
<style lang="scss" scoped>

    .NewsGrid {
        margin-top: getSpacing('large');
        margin-bottom: getSpacing('large');

        @include media-query(desk) {
            margin-top: getSpacing('xlarge');
            margin-bottom: getSpacing('xlarge');
        }
    }

    .NewsGrid__list {
        display:-ms-grid;
        display: grid;
        -ms-grid-columns: 1fr 1fr;
        grid-template-columns: repeat(2, 1fr);
        -ms-grid-rows: 1fr;
        grid-template-rows: repeat(1, 1fr);


        @include media-query(lap-and-up) {
            -ms-grid-columns: 1fr 1fr 1fr;
            grid-template-columns: repeat(3, 1fr);
        }
    }

    .NewsGrid__list--large {
        -ms-grid-rows: 1fr 1fr;
        grid-template-rows: repeat(2, 1fr);

        @include media-query(palm) {

        }
    }

    .NewsCard {
        .NewsGrid__list:not(.NewsGrid__list--large) & {
            @include media-query(palm) {
                display: none;

                &:first-child, &:nth-child(2) {
                    display: block;
                }
            }
        }

        &:nth-child(1) {
            -ms-grid-column: 1;
            -ms-grid-row: 1;
        }
        &:nth-child(2) {
            -ms-grid-column: 2;
            -ms-grid-row: 1;
        }
        &:nth-child(3) {
            -ms-grid-column: 1;
            -ms-grid-row: 2;

            @include media-query(lap-and-up) {
                -ms-grid-column: 3;
                -ms-grid-row: 1;
            }
        }
        &:nth-child(4) {
            -ms-grid-column: 2;
            -ms-grid-row: 2;

            @include media-query(lap-and-up) {
                -ms-grid-column: 1;
                -ms-grid-row: 2;
            }
        }
        &:nth-child(5) {
            -ms-grid-column: 1;
            -ms-grid-row: 3;

            @include media-query(lap-and-up) {
                -ms-grid-column: 2;
                -ms-grid-row: 2;
            }
        }
        &:nth-child(6) {
            -ms-grid-column: 2;
            -ms-grid-row: 3;

            @include media-query(lap-and-up) {
                -ms-grid-column: 3;
                -ms-grid-row: 2;
            }
        }
    }
</style>
